module.exports = __webpack_public_path__ + "img/loginBg.1ea6f8a3.png";